import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { meta } from "@/lib/metaPixel";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { exchangeGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const run = async () => {
      // Read session_id from hash first (spec), fall back to query string
      // in case some mobile browsers strip the hash across the OAuth bounce.
      const hashParams = new URLSearchParams((window.location.hash || "").replace(/^#/, ""));
      const queryParams = new URLSearchParams(window.location.search || "");
      const sessionId = hashParams.get("session_id") || queryParams.get("session_id");
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const user = await exchangeGoogle(sessionId);
        // Meta: fire CompleteRegistration only for NEW Google users. The
        // trackConversionOnce guard uses persistent localStorage keyed by
        // user_id, so returning users who already fired the event will not
        // fire it again — even if they land here after an OAuth re-bounce.
        if (user?.user_id) meta.completeRegistration(user.user_id);
        // Strip the hash / session_id param and route to dashboard — the
        // Welcome / setup checklist there nudges onboarding when incomplete.
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    };
    run();
  }, [exchangeGoogle, navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="text-[#64748B] text-sm tracking-wide">Establishing your dive…</div>
    </div>
  );
}
